<div class="query-preview">
    <grid *ngIf="tableSettings && gridSettings"
          [tableSettings]="tableSettings"
          [gridSettings]="gridSettings"
          (onRowSelect)="onGridRowSelect($event)">
    </grid>
</div>